export const isInstantBookingEnabled = ({ listing, type }) => {
  const publicData = listing?.attributes.publicData || {};

  return publicData[type]?.isAllowInstantBooking === 'yes' || publicData.isInstantBooking;
};

export const getCancellationPolicy = ({ listing, type }) => {
  const publicData = listing?.attributes.publicData || {};
  return publicData[type]?.cancellationPolicy || publicData.cancellationPolicy;
};
